<template>
    <div>
        <div class="or-admin-product-constructor-text">
            <div v-html="text" :style="options.style">
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex';
export default {
    props: {
        options: Object,
    },
    computed: {
        text() {
            const div = document.createElement('div');
            this.convertText({text: this.options.text.value, container: div});
            return div.innerHTML;
        }
    },
    methods: {
        ...mapActions({convertText: 'convertText'}),
    }
}
</script>

<style scoped>
    .or-admin-product-constructor-text {
        position: relative;
    }
</style>